import type { AuditEvent } from "./api";
import type { PickOption } from "./search";

export interface AuditFilter {
  /** Who acted, chosen from `auditActors`; matched exactly, ignoring case. "" for anyone. */
  who: string;
  /** An exact action (key.retag, sign-in, ...), or "" for any. */
  action: string;
}

/** The actions present in the events, sorted, for the Action select. */
export function auditActions(events: AuditEvent[]): string[] {
  return [...new Set(events.map((e) => e.action))].sort();
}

/** Everyone who acted in the events, once each however their case varies, for the Who picker. */
export function auditActors(events: AuditEvent[]): PickOption[] {
  const seen = new Map<string, string>();
  for (const e of events) if (!seen.has(e.actor.toLowerCase())) seen.set(e.actor.toLowerCase(), e.actor);
  return [...seen].map(([value, label]) => ({ value, label })).sort((a, b) => a.label.localeCompare(b.label));
}

export function filterEvents(events: AuditEvent[], f: AuditFilter): AuditEvent[] {
  const who = f.who.trim().toLowerCase();
  return events.filter((e) => (!who || e.actor.toLowerCase() === who) && (!f.action || e.action === f.action));
}
